import { Category } from "@/dto/category";
import { GetAllItemsResponse } from "@/dataLayer/getAllItems";
import { Menu } from "@/dto/menu";

export interface CategoryItemsData {
  elements: any[];
  currentPage: number;
  totalPages: number;
  totalItemCount: number;
}

interface AllItemsCacheEntry {
  params: string;
  data: GetAllItemsResponse;
}

let categoryItemsCache: Map<string, CategoryItemsData> = new Map();
let allItemsCache: AllItemsCacheEntry | null = null;
let retailItemsCache: any[] | null = null;
let serviceItemsCache: Category[] | null = null;
let menuCache: Menu | null = null;

// retail /all page
export const getAllItemsFromCache = (
  searchParams: URLSearchParams
): GetAllItemsResponse | null => {
  if (!allItemsCache) {
    return null;
  }
  if (allItemsCache.params === searchParams.toString()) {
    return allItemsCache.data;
  }
  return null;
};

export const setAllItemsInCache = (
  data: GetAllItemsResponse | null,
  searchParams: URLSearchParams
) => {
  if (data) {
    allItemsCache = {
      params: searchParams.toString(),
      data: data,
    };
  } else {
    allItemsCache = null;
  }
};

export const areParamsMatchingCache = (
  searchParams: URLSearchParams
): boolean => {
  if (!allItemsCache) {
    return false;
  }
  return allItemsCache.params === searchParams.toString();
};

// retail category pages
export const getCategoryItemsFromCache = (
  categoryId: string
): CategoryItemsData | null => {
  return categoryItemsCache.get(categoryId) || null;
};

export const setCategoryItemsInCache = (
  categoryId: string,
  data: CategoryItemsData | null
) => {
  if (data) {
    categoryItemsCache.set(categoryId, data);
  } else {
    categoryItemsCache.delete(categoryId);
  }
};

// hybrid shop tab
export const getRetailItemsFromCache = (): any[] | null => {
  return retailItemsCache;
};

export const setRetailItemsInCache = (items: any[] | null) => {
  retailItemsCache = items;
};

// hybrid services tab
export const getServiceItemsFromCache = (): Category[] | null => {
  return serviceItemsCache;
};

export const setServiceItemsInCache = (items: Category[] | null) => {
  serviceItemsCache = items;
};

// restaurant & services menu tab
export const getMenuFromCache = (): Menu | null => {
  return menuCache;
};

export const setMenuInCache = (menu: Menu | null) => {
  menuCache = menu;
};
